import React, {useState} from 'react';

import {ToggleButton} from '@mui/material';
import {ButtonPropsDefaults, ButtonPropsSchema} from '@usewaypoint/block-button';

import BaseSidebarPanel from './helpers/BaseSidebarPanel';
import ColorInput from './helpers/inputs/ColorInput';
import RadioGroupInput from './helpers/inputs/RadioGroupInput';
import TextInput from './helpers/inputs/TextInput';
import MultiStylePropertyPanel from './helpers/style-inputs/MultiStylePropertyPanel';


export default function ButtonSidebarPanel({data, setData}) {
    const [, setErrors] = useState(null);

    const updateData = (d) => {
        const res = ButtonPropsSchema.safeParse(d);
        if (res.success) {
            setData(res.data);
            setErrors(null);
        } else {
            setErrors(res.error);
        }
    };

    const text = data.props?.text ?? ButtonPropsDefaults.text;
    const url = data.props?.url ?? ButtonPropsDefaults.url;
    const fullWidth = data.props?.fullWidth ?? ButtonPropsDefaults.fullWidth;
    const size = data.props?.size ?? ButtonPropsDefaults.size;
    const buttonStyle = data.props?.buttonStyle ?? ButtonPropsDefaults.buttonStyle;
    const buttonTextColor = data.props?.buttonTextColor ?? ButtonPropsDefaults.buttonTextColor;
    const buttonBackgroundColor = data.props?.buttonBackgroundColor ?? ButtonPropsDefaults.buttonBackgroundColor;

    return (
        <BaseSidebarPanel title="Button block">
            <TextInput
                label="Text"
                defaultValue={text}
                onChange={(text) => updateData({...data, props: {...data.props, text}})}
            />
            <TextInput
                label="Url"
                defaultValue={url}
                onChange={(url) => updateData({...data, props: {...data.props, url}})}
            />
            <RadioGroupInput
                label="Width"
                defaultValue={fullWidth ? 'FULL_WIDTH' : 'AUTO'}
                onChange={(v) => updateData({...data, props: {...data.props, fullWidth: v === 'FULL_WIDTH'}})}
            >
                <ToggleButton value="FULL_WIDTH">Full</ToggleButton>
                <ToggleButton value="AUTO">Auto</ToggleButton>
            </RadioGroupInput>
            <RadioGroupInput
                label="Size"
                defaultValue={size}
                onChange={(size) => updateData({...data, props: {...data.props, size}})}
            >
                <ToggleButton value="x-small">Xs</ToggleButton>
                <ToggleButton value="small">Sm</ToggleButton>
                <ToggleButton value="medium">Md</ToggleButton>
                <ToggleButton value="large">Lg</ToggleButton>
            </RadioGroupInput>
            <RadioGroupInput
                label="Style"
                defaultValue={buttonStyle}
                onChange={(buttonStyle) => updateData({...data, props: {...data.props, buttonStyle}})}
            >
                <ToggleButton value="rectangle">Rectangle</ToggleButton>
                <ToggleButton value="rounded">Rounded</ToggleButton>
                <ToggleButton value="pill">Pill</ToggleButton>
            </RadioGroupInput>
            <ColorInput
                label="Text color"
                defaultValue={buttonTextColor}
                onChange={(buttonTextColor) => updateData({...data, props: {...data.props, buttonTextColor}})}
            />
            <ColorInput
                label="Button color"
                defaultValue={buttonBackgroundColor}
                onChange={(buttonBackgroundColor) => updateData({
                    ...data,
                    props: {...data.props, buttonBackgroundColor}
                })}
            />
            <MultiStylePropertyPanel
                names={['backgroundColor', 'fontFamily', 'fontSize', 'fontWeight', 'textAlign', 'padding']}
                value={data.style}
                onChange={(style) => updateData({...data, style})}
            />
        </BaseSidebarPanel>
    );
}
